import React from 'react';
import PropTypes from 'prop-types';
import AddBox from 'material-ui/svg-icons/content/add-box';
import IconButton from 'material-ui/IconButton';
import { primaryBlue } from 'theme/mainColors';

const TTAddColumn = ({ ttActions, translationTableId, disabled }) => {
  const handleAddColumnClick = () => ttActions.createColumn('MATCH', translationTableId);

  return (
    <div className={ 'tt-column-manager__add-column' }>
      <IconButton onClick={ handleAddColumnClick } disabled={ disabled }>
        <AddBox color={ primaryBlue } />
      </IconButton>
    </div>
  );
};

TTAddColumn.propTypes = {
  disabled: PropTypes.bool,
  translationTableId: PropTypes.number.isRequired,
  ttActions: PropTypes.shape({
    createColumn: PropTypes.func
  }).isRequired
};

TTAddColumn.defaultProps = {
  disabled: false
};

export default TTAddColumn;



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttColumnManager/c/ttAddColumn/TTAddColumn.js